import { useQuery } from 'hooks/useCustomQuery';
import getPlans from '@/API/getPlans';

const useGetPlans = ({ companyId, partnerId, wholesalerId, setPlans }) => {
    return useQuery({
        queryKey: ['plans', companyId, partnerId, wholesalerId],
        queryFn: async () => {
            const plans = await getPlans({
                companyId,
                partnerId,
                wholesalerId,
            });
            setPlans(plans);
            return plans;
        },
        refetchOnWindowFocus: false,
        enabled: !!companyId || !!partnerId || !!wholesalerId,
        staleTime: 0,
    });
};

export default useGetPlans;
